import { render, staticRenderFns } from "./UiToggler.vue?vue&type=template&id=cfecdb2a&lang=pug&"
import script from "./UiToggler.vue?vue&type=script&lang=js&"
export * from "./UiToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports